import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { ErrorView, Loader } from '@percent/cause-dashboard/common/components'
import { useAuthState, useQuery, useQueryList } from '@percent/cause-dashboard/common/hooks'
import { dayJS } from '@percent/cause-dashboard/common/utility/date'
import { toCurrencyMap } from '@percent/cause-dashboard/common/utility/money/currencyMap'
import { useServices } from '@percent/cause-dashboard/context/serviceContext/ServiceContext'
import { Flex } from '@percent/lemonade'
import { useBreadcrumbs } from '../../layout/breadcrumbsContext/useBreadcrumbs/useBreadcrumbs'
import { RoutePath } from '../../routes/Routes'
import { DonationsIncludedList } from './DonationsIncludedList/DonationsIncludedList'
import { PayoutDetails } from './PayoutDetails/PayoutDetails'

export function PayoutDetailsPage() {
  const { t } = useTranslation()
  useBreadcrumbs([
    { label: t('breadcrumb.payouts'), path: RoutePath.PAYOUTS },
    { label: t('breadcrumb.payoutDetails') }
  ])

  const { pathname } = useLocation()
  const payoutId = pathname.substring(pathname.lastIndexOf('/') + 1, pathname.length)

  const { payoutsService } = useServices()
  const {
    currencyInfo,
    authState: { user }
  } = useAuthState()

  const currencyMap = toCurrencyMap(currencyInfo)

  const [payoutDetailsResponse] = useQuery(payoutsService.getPayoutDetails, {
    organisationId: user?.organisationId as string,
    disbursementId: payoutId
  })

  const [{ data, totalResults, isLoading, errorMessage }, { nextPage, previousPage }] = useQueryList(
    payoutsService.getPayoutDonationsIncludedList(user?.organisationId as string, payoutId)
  )

  if (payoutDetailsResponse.errorMessage || errorMessage) {
    return <ErrorView errorMessage={payoutDetailsResponse.errorMessage || errorMessage} />
  }

  if (payoutDetailsResponse.isLoading || isLoading) {
    return <Loader />
  }

  return (
    <Flex gap={24} direction="column" wrap="nowrap">
      <PayoutDetails data={payoutDetailsResponse.data?.data.data} currencyMap={currencyMap} />

      <DonationsIncludedList
        currencyMap={currencyMap}
        payoutId={payoutId}
        payoutDate={dayJS(payoutDetailsResponse?.data?.data.data.paidAt).format('YYYY-MM-DD')}
        data={data}
        totalResults={totalResults}
        nextPage={nextPage}
        previousPage={previousPage}
      />
    </Flex>
  )
}
